import styled from 'styled-components';
import theme from '../../styled/shared/Theme';

const StyledLogo = styled.img`
  height: 180px;
  margin-top: 10vmin;
  margin-bottom: ${theme.spacingL};
`;

export default StyledLogo;
